import Vue from 'vue'

export default function (pluginsHandler) {
    return {
        name: 'search',
        style: 'themes/' + pluginsHandler.getTheme() + '.css',
        treeMixins: {
            props: {
                searchPlaceholder: {
                    type: [String, Number],
                    default: 'Search ...'
                },
                searchFilterValue: {
                    type: [String],
                    default: ''
                },
                searchNotFoundText: {
                    type: String,
                    default: 'No items found'
                },
                searchOnBeforeFilter: {
                    type: Function,
                    default: (searchKey) => {
                        return true
                    }
                },
                searchOnAfterFilter: {
                    type: Function,
                    default: (searchKey, result) => {return;}
                },
                searchComparator:{
                    type: Function,
                    default: (searchKey, currentElement, tree) => {
                        return currentElement.rowItem[tree.defaultPropertyTitleKey] === searchKey
                    }
                }
            },
            data: function () {
                return {
                    search: '',
                    searchResult: [],
                    searchIsFilterApplied: false
                }
            },
            methods: {
                searchFind() {
                    let search = this.search
                    let hasFilter = search.length !== 0
                    this.searchResult = []

                    if (!this.searchOnBeforeFilter(search)) return

                    function setToVisible(children, status) {
                        children.forEach(function (child) {
                            if (child.rowItem && child.rowItem.internal) {
                                Vue.set(child.rowItem.internal, 'search-found', false)
                            }

                            child.searchIsVisible = true
                            if (child.isFolder)
                                child.open = status

                            if (child.$children && child.$children.length > 0) {
                                setToVisible(child.$children, status)
                            }
                        })
                    }

                    setToVisible(this.$children, !pluginsHandler.plugins.has('collapse') || // if collapsed is disabled open all folder nodes
                        hasFilter ||
                        this.collapseStartExpanded)

                    let result = []
                    let self = this;
                    function doSearch(children) {

                        let isFound = false

                        children.forEach(child => {
                            if (child.rowItem) {

                                child.searchIsVisible = false
                                if (self.searchComparator(search, child, self)) {
                                    child.searchIsVisible = true

                                    // save reference of found object
                                    result.push(child)

                                    // mark found item
                                    child.rowItem.internal['search-found'] = true

                                    // open if it is folder
                                    if (child.isFolder) {
                                        child.open = true
                                    }

                                } else {
                                    // if parent of item is in search result and it is folder, shows its items
                                    if (child.$parent.open && child.$parent.searchIsVisible) {
                                        child.searchIsVisible = true
                                        // if collapsed is disabled open all folder nodes
                                        child.open = !pluginsHandler.plugins.has('collapse')
                                    }
                                }
                            }

                            if (child.$children.length > 0) {
                                let hasFound = doSearch(child.$children)

                                if (hasFound) {
                                    child.searchIsVisible = true
                                    if (child.isFolder) {
                                        child.open = true
                                    }
                                }
                            }

                            if (child.searchIsVisible && child.rowItem) {
                                isFound = true
                            }
                        })

                        return isFound
                    }

                    this.$nextTick(() => {
                        if (hasFilter) {
                            doSearch(this.$children)
                            this.searchOnAfterFilter(search, result)
                            this.searchResult = result

                            function setChildrenVisible(children) {
                                children.forEach(subChild => {
                                    subChild.searchIsVisible = true

                                    if (subChild.isFolder && subChild.rowItem.internal['search-is-found']) {
                                        subChild.open = !pluginsHandler.plugins.has('collapse')
                                    }

                                    if (subChild.$children.length) {
                                        setChildrenVisible(subChild.$children)
                                    }
                                })
                            }

                            setChildrenVisible(result)
                        }

                        // controlled collapse plugin all nodes
                        if (pluginsHandler.plugins.has('collapse')) {
                            this.collapseIsCollapsed = !Boolean(result.length)

                            if (this.collapseStartExpanded)
                                this.collapseIsCollapsed = false
                        }

                    })

                    this.searchIsFilterApplied = hasFilter && !result.length
                },
                searchGetFound() {
                    return this.searchResult
                }
            },
            mounted() {
                // apply default filter
                this.search = this.searchFilterValue
                this.searchFind()
            }
        },
        treeRowMixins: {
            data() {
                return {
                    searchIsVisible: true
                }
            }
        },
        rowIf: "searchIsVisible",
        slotsContent: {
            'beforeTree': `<oc-text-input
                                v-on:keypress.enter.prevet="searchFind"
                                v-model="search" name="search-tree"
                                :placeholder="searchPlaceholder"
                                class="oc-tree-search-input"
                            />
                            <oc-button-input class="btn btn-sm btn-success oc-tree-search-button" @click.prevent="searchFind">Find</oc-button-input>`,
            'rowPrepend': `<span data-oc-tree-search-plugin-css :class="{'search-found': rowItem.internal['search-found']}">`,
            'rowAfterTitle': `</span>`,
            'afterTree': '<span class="oc-tree-search-not-found" v-if="searchIsFilterApplied && !searchResult.length">{{searchNotFoundText}}</span>'
        },
        processData(data, tree) {
            function appendData(source) {
                Object.keys(source).forEach((key) => {
                    // search plugin data
                    Vue.set(source[key].internal, 'search-found', false)

                    if (source[key][tree.defaultSubItemsKey]) {
                        appendData(source[key].children)
                    }
                })
            }

            appendData(data);

            return data;
        }
    }
}
